import { useWidgetMessages } from 'widgets/store/stream/selectors';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import {
    useDispatchUpdateWidgetConfiguration,
    useWidgetConfigState,
} from 'widgets/store/configuration/hooks';

export const useShowHideWidgetToolbar = <T = WidgetConfigWithHideableToolbar>(
    mustShow: boolean,
    propertyNameP?: keyof T
) => {
    const propertyName = propertyNameP ?? ('hideToolbar' as keyof T);
    const config = useWidgetConfigState<T>();
    const hideToolbar = config ? !!config[propertyName] : false;

    const dispatchUpdateWidgetConfig = useDispatchUpdateWidgetConfiguration();

    // Always show, and do not allow collapse, if there are warning messages...
    const messages = useWidgetMessages();
    const allowCollapse = !mustShow && messages.length === 0;

    const toggleCollapse = () => {
        const delta = { [propertyName]: !hideToolbar };
        dispatchUpdateWidgetConfig(delta);
    };

    const showToolbar =
        mustShow || !allowCollapse || (allowCollapse && !hideToolbar);

    return { showToolbar, allowCollapse, toggleCollapse };
};
